import { type CSSProperties } from "react"

/**
 * Wraps a Material Symbols Outlined ligature. The font is loaded once in
 * index.html; this component only ever supplies the glyph name and sizing.
 */
export function Icon({
	name,
	size = 20,
	filled = false,
	className,
}: {
	name: string
	size?: number
	filled?: boolean
	className?: string
}) {
	const style: CSSProperties = {
		fontSize: size,
		width: size,
		height: size,
		fontVariationSettings: filled ? "'FILL' 1" : "'FILL' 0",
	}

	return (
		<span
			aria-hidden="true"
			className={`material-symbols-outlined inline-flex shrink-0 items-center justify-center leading-none ${className ?? ""}`}
			style={style}
		>
			{name}
		</span>
	)
}
